import React from "react";

const ScholarshipEventsBanner = () => {
  return (
    <div className="w-full lg:min-h-[657px] bg-gradient-to-b from-[#EDFCFF] to-[#89C9ED]  ">
      <div className="container mx-auto flex flex-col md:flex-row justify-between ">
        <div className="flex flex-col md:w-3/5 gap-3">
          <div
            className="rounded-[10px] bg-white shadow-[3px_3px_15px_0px_rgba(0,0,0,0.15)] xl:mt-32"
            style={{ width: "562.538px", height: "232px", flexShrink: 0 }}
          >
            <img
              src="/images/scholarship-events-banner1.webp"
              alt="College Mentor Scholarship 2025"
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-[#173CBA] font-roboto text-[24px] font-medium leading-[36px]">
            Meet representatives from top Universities
          </span>
          <span className="text-[#173CBA] font-roboto text-[24px] font-bold leading-[32px] mt-2">
            On May 12, 2025 A Plus Convention Center <br />
            Vijayawada Andhra Pradesh
          </span>
          <div className="">
            <button className="bg-[#0C9]  text-white text-[16px] font-semibold px-6 py-3 rounded">
              Register now
            </button>
          </div>
          <div className="flex gap-[11px] ">
            <button className="bg-[#173CBA]  text-white px-6 py-2 rounded">
              For Colleges & Universities →
            </button>
            <button className="bg-[#173CBA]  text-white px-6 py-2 rounded">
              For Students & Parents →
            </button>
          </div>
        </div>
        <div className="flex md:w-2/5 ">
          <img
            src="/images/scholarship-events-banner.webp"
            alt="Graduated student"
            className="w-full "
          />
        </div>
      </div>
    </div>
  );
};

export default ScholarshipEventsBanner;
